import * as React from 'react';

// tslint:disable:max-line-length
export const PoliceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M14.35 5.835l-3.837-.559L8.8 1.8a.925.925 0 0 0-1.6 0L5.487 5.277l-3.837.558a.889.889 0 0 0-.494 1.516l2.776 2.707-.656 3.822a.889.889 0 0 0 1.29.937L8 13.012l3.432 1.803a.889.889 0 0 0 1.29-.937l-.655-3.822 2.777-2.705a.889.889 0 0 0-.492-1.515l-.002-.001z"
    />
  </svg>
);
